import React from 'react';
import styled from 'styled-components';
import Link from '@ntuctech/devex-tangram/Link';
import Accordion from '../../Accordion';

const StyledText = styled.div`
  line-height: 1.25rem;
  padding: 0 1rem 1rem 1rem;
  a {
    color: var(--bold-title-color);
    font-weight: 700;
  }
`;

const HelpAndEnquiriesAccordion = ({ expand }) => {
  return (
    <Accordion title="For help or enquiries" expand={expand}>
      <StyledText>
        If you encounter a problem using the voucher code,
        <Link
          size="l"
          href="https://help.fairprice.com.sg/hc/en-us/requests/new?ticket_form_id=360000029352"
          target="_blank"
          rel="noopener noreferrer"
          css="margin: 0 0.3125rem"
        >
          please submit a ticket
        </Link>
        via our online customer service form. Under the “Tell us more” field, include the voucher
        code in your message.
      </StyledText>
    </Accordion>
  );
};

export default HelpAndEnquiriesAccordion;
